import React from "react";
import { ShieldCheck } from "lucide-react";
import { TransformedProfileData } from "@/types/publicProfile";
import { Section } from "./Section";

interface ServicesSectionProps {
  services: TransformedProfileData["sections"]["services"]["items"];
}

export const ServicesSection: React.FC<ServicesSectionProps> = ({
  services,
}) => {
  return (
    <Section
      id="services"
      title="Services"
      icon={<ShieldCheck className="h-5 w-5" />}
    >
      <div className="grid gap-4 md:grid-cols-3">
        {services
          .filter((service) => service.privacy.isVisible)
          .map((service) => (
            <article key={service.id} className="card-apple p-5">
              <div className="flex items-start justify-between mb-2">
                <h3 className="text-base font-semibold">{service.title}</h3>
                {service.featured && (
                  <span className="pill-apple text-xs bg-yellow-100 text-yellow-800">
                    Featured
                  </span>
                )}
              </div>
              <p className="text-sm text-secondary mb-3">
                {service.description}
              </p>
              {service.price && (
                <div className="text-sm font-medium text-primary mb-2">
                  {service.price}
                </div>
              )}
              {service.duration && (
                <div className="text-xs text-tertiary mb-2">
                  Duration: {service.duration}
                </div>
              )}
              {service.deliverables && service.deliverables.length > 0 && (
                <div className="mt-3">
                  <div className="text-xs font-medium text-primary mb-1">
                    Includes:
                  </div>
                  <ul className="text-xs text-secondary space-y-1">
                    {service.deliverables &&
                      service.deliverables.map(
                        (deliverable: string, index: number) => (
                          <li key={index} className="flex items-start gap-1">
                            <span className="text-primary mt-1">•</span>
                            <span>{deliverable}</span>
                          </li>
                        )
                      )}
                  </ul>
                </div>
              )}
            </article>
          ))}
      </div>
    </Section>
  );
};
